<template>
  <v-container
    fluid
    style="margin-top: 0%; padding: 0% 0% 0 0; min-height: calc(100vh - 58px)"
  >
    <v-row style="height: 100%; margin: 0; padding: 0; position: relative">
      <v-col cols="12" class="pa-0">
        <GlobalNav />
      </v-col>
      <v-col cols="12" class="pa-0 d-flex align-start ga-6">
        <SideBar />
        <div class="ad-performance-contant">
          <BreadCrumb :linksData="store.linksData" class="mb-5" />
          <div class="result-last-days">
            <h4 class="mb-3">
              {{ store.title_date }}
            </h4>
            <v-container fluid class="py-0 px-1">
              <v-row class="w-100 pa-0 ma-0">
                <v-col
                  cols="11"
                  xl="12"
                  md="12"
                  sm="12"
                  class="results-card ga-8 pa-0"
                >
                  <v-card class="card rounded-xl px-7 py-12">
                    <v-row>
                      <v-col cols="4" :md="4" :sm="4">
                        <div
                          class="compaigns-result d-flex align-center d-sm-block d-md-flex"
                        >
                          <div class="icon-contain">
                            <img
                              src="@/assets/soft-ware-img/ads-performance-campaign.svg"
                              alt=""
                            />
                          </div>
                          <div class="result-contain">
                            <p class="number">
                              {{ store.formatNumber(store.campaignNumber) }}
                            </p>
                            <p class="title">{{ $t("compaigns") }}</p>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="4" :md="4" :sm="4">
                        <div
                          class="compaigns-result d-flex align-center d-sm-block d-md-flex"
                        >
                          <div class="icon-contain">
                            <img
                              src="@/assets/soft-ware-img/amount-icon-dollar.svg"
                              alt=""
                            />
                          </div>
                          <div class="result-contain">
                            <p class="number">
                              {{ store.formatNumber(store.amountSpent) }}$
                            </p>
                            <p class="title">{{ $t("amount_spent") }}</p>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="4" :md="4" :sm="4">
                        <div
                          class="compaigns-result d-flex align-center d-sm-block d-md-flex"
                        >
                          <div class="icon-contain">
                            <img
                              src="@/assets/soft-ware-img/impressions-icon.svg"
                              alt=""
                            />
                          </div>
                          <div class="result-contain">
                            <p class="number">
                              {{ store.formatNumber(store.impressions) }}
                            </p>
                            <p class="title">{{ $t("impressions") }}</p>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="4" :md="4" :sm="4">
                        <div
                          class="compaigns-result d-flex align-center d-sm-block d-md-flex"
                        >
                          <div class="icon-contain">
                            <img
                              src="@/assets/soft-ware-img/leads-ad-performance-icon.svg"
                              alt=""
                            />
                          </div>
                          <div class="result-contain">
                            <p class="number">
                              {{ store.formatNumber(store.leads) }}
                            </p>
                            <p class="title">{{ $t("leads") }}</p>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="4" :md="4" :sm="4">
                        <div
                          class="compaigns-result d-flex align-center d-sm-block d-md-flex"
                        >
                          <div class="icon-contain">
                            <img
                              src="@/assets/soft-ware-img/click-icon.svg"
                              alt=""
                            />
                          </div>
                          <div class="result-contain">
                            <p class="number">
                              {{ store.formatNumber(store.clicks) }}
                            </p>
                            <p class="title">{{ $t("click") }}</p>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                  <div class="actions-on-performance">
                    <Selectaccid />
                    <button
                      @click="dialog = true"
                      class="add-campaign-btn d-flex align-center ga-1"
                    >
                      <span class="d-flex">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="20px"
                          viewBox="0 -960 960 960"
                          width="20px"
                          fill="#fff"
                        >
                          <path
                            d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                          />
                        </svg>
                      </span>
                      <span>{{ $t("add_compaign") }}</span>
                    </button>
                    <v-dialog
                      v-model="dialog"
                      width="auto"
                      class="add-campaign-modal"
                    >
                      <v-card
                        min-width="600"
                        class="dialog-card pa-4 rounded-xl"
                      >
                        <div
                          class="card-title d-flex justify-space-between align-center"
                        >
                          <p>{{ $t("select_social_media_Platform") }}</p>
                          <img
                            @click="dialog = false"
                            src="@/assets/soft-ware-img/X circle.svg"
                            alt=""
                          />
                        </div>
                        <v-card-text>
                          <div>
                            <router-link
                              to="/create-new-camp"
                              style="border: 1px solid #1094f4"
                            >
                              <span>
                                <img
                                  src="@/assets/soft-ware-img/facebook-icon-adcampaign.svg"
                                  alt=""
                                />
                              </span>
                              <span> {{ $t("facebook") }} </span>
                            </router-link>
                            <router-link
                              to="/create-new-camp"
                              style="border: 0.6px solid #b731a0"
                            >
                              <span>
                                <img
                                  src="@/assets/soft-ware-img/instgrapm.svg"
                                  alt=""
                                />
                              </span>

                              <span> {{ $t("instagram") }} </span>
                            </router-link>
                            <router-link
                              to="/create-new-camp"
                              style="border: 1px solid #fffa37"
                            >
                              <span>
                                <img
                                  src="@/assets/soft-ware-img/snapchat-icoon-ccampaign.svg"
                                  alt=""
                                />
                              </span>
                              <span> {{ $t("snapchat") }} </span>
                            </router-link>
                          </div>
                          <div>
                            <router-link
                              to="/create-new-camp"
                              style="border: 1px solid #1275b1"
                            >
                              <span>
                                <img
                                  src="@/assets/soft-ware-img/linkedin-icon.svg"
                                  alt=""
                                />
                              </span>
                              <span> {{ $t("linked_in") }} </span>
                            </router-link>

                            <router-link
                              to="/create-new-camp"
                              style="border: 1px solid #000000"
                            >
                              <span>
                                <img
                                  src="@/assets/soft-ware-img/tikTopkcampaign.svg"
                                  alt=""
                                />
                              </span>
                              <span> {{ $t("tik_tok") }} </span>
                            </router-link>

                            <router-link
                              to="/create-new-camp"
                              style="border: 1px solid #000000"
                            >
                              <span>
                                <img
                                  src="@/assets/soft-ware-img/x-twitter-icons.svg"
                                  alt=""
                                />
                              </span>
                              <span> {{ $t("x") }} </span>
                            </router-link>
                          </div>
                        </v-card-text>
                        <div class="card-footer">
                          <span
                            >* {{ $t("you_can_choose_multiple_platform") }}
                          </span>

                          <button>{{ $t("add_compaign") }}</button>
                        </div>
                      </v-card>
                    </v-dialog>
                    <!-- <button
                      @click="adsReportStatusFunc"
                      class="ads-report-btn d-flex align-center ga-2"
                    >
                      <span class="d-flex">
                        <img
                          src="@/assets/soft-ware-img/ads-report-icon.svg"
                          alt=""
                        />
                      </span>
                      <span v-if="this.store.adsReportStatus">{{
                        $t("ads_report")
                      }}</span>
                      <span v-else> Ads Table</span>
                    </button> -->
                    <button
                      @click="exportTable"
                      class="export-btn d-flex align-center ga-2"
                    >
                      <span class="d-flex">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24px"
                          viewBox="0 -960 960 960"
                          width="24px"
                          fill="rgba(35, 114, 118, 1)"
                        >
                          <path
                            d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"
                          />
                        </svg>
                      </span>
                      <span>{{ $t("export_file") }}</span>
                    </button>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  xl="12"
                  md="12"
                  sm="12"
                  class="d-lg-block d-md-flex d-sm-block my-5 align-center justify-space-between flex-wrap"
                >
                  <v-row>
                    <v-col cols="10" :lg="9" :md="8" :sm="12">
                      <div
                        class="filter-contain d-flex align-center ga-5 w-lg-100"
                      >
                        <v-row>
                          <v-col cols="3" :md="3" :sm="6">
                            <div class="select-date">
                              <label for="">{{ $t("date") }}</label>

                              <v-date-input
                                prepend-icon=""
                                prepend-inner-icon="$calendar"
                                v-model="store.selectedDate"
                                multiple="range"
                                variant="solo"
                                elevation="0"
                              ></v-date-input>
                            </div>
                          </v-col>
                          <v-col cols="3" :md="3" :sm="6">
                            <div class="select-status">
                              <label for="" class="d-block mb-2">{{
                                $t("status")
                              }}</label>
                              <v-select
                                v-model="store.selectedStatus"
                                :items="statusItems"
                                item-text="text"
                                item-value="value"
                                :label="$t('select')"
                                persistent-hint
                                return-object
                                single-line
                                variant="solo"
                                elevation="0"
                              ></v-select>
                            </div>
                          </v-col>
                          <v-col cols="3" :md="3" :sm="12">
                            <div class="select-status">
                              <div class="select-status">
                                <label for="" class="d-block mb-2">
                                  {{ $t("platform") }}
                                </label>
                                <v-select
                                  v-model="store.selectedPlatform"
                                  :items="platformItems"
                                  item-title="platform"
                                  item-value="platform"
                                  label="Select Platform"
                                  persistent-hint
                                  return-object
                                  single-line
                                  variant="solo"
                                  elevation="0"
                                ></v-select>
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="3" :md="3" :sm="12">
                            <div class="actions-on-performance">
                              <button
                                @click="ApplyFilter"
                                class="add-campaign-btn d-flex align-center ga-1 mt-lg-9 mt-md-9 mt-sm-0"
                              >
                                <span> {{ $t("apply") }} </span>
                              </button>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                    <v-col cols="12" :lg="3" :md="4" :sm="12">
                      <div
                        class="d-flex gap-4 align-center ga-4 mt-lg-6 mt-md-6 mt-sm-0 justify-sm-center justify-md-end"
                      >
                        <div class="hide-filter">
                          <button
                            @click="toggleFilter"
                            class="d-flex align-center ga-2 mt-lg-6 mt-md-6 mt-sm-0"
                          >
                            <span
                              ><img
                                src="@/assets/soft-ware-img/filter-icon-performance.svg"
                                alt=""
                            /></span>
                            <span>
                              <span>{{ $t("Reset") }}</span>
                              {{ $t("filters") }}</span
                            >
                          </button>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="table-contain">
                    <CampaignTable
                      :campaigns="campaigns"
                      :total="total"
                      :loading="loading"
                      :page="page"
                      :perPage="perPage"
                      @update:page="onPageChange"
                      @update:perPage="onPerPageChange"
                      @change-status="handleStatusChange"
                      ref="tableRef"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GlobalNav from "@/components/layout/GlobalNav.vue";
import SideBar from "@/components/layout/SideBar.vue";
import BreadCrumb from "@/components/layout/BreadCrumb.vue";
import { VDateInput } from "vuetify/labs/VDateInput";
import apiClient from "@/core/buildRequest.js";
import VerticalBarChart from "@/components/VerticalBarChart.vue";
import "@/assets/css/style.css";
import * as XLSX from "xlsx";
import { adsPerformance } from "@/store/AdsPerformance/ads_performance";
import { useGeneralStore } from "@/store/General";
import { toast } from "vue3-toastify";
import Selectaccid from "@/components/AdsPerformance/selectaccid.vue";
import CampaignTable from "@/components/AdsPerformance/CampaignTable.vue";

export default {
  components: {
    GlobalNav,
    SideBar,
    BreadCrumb,
    VDateInput,
    VerticalBarChart,
    Selectaccid,
    CampaignTable,
  },
  data() {
    return {
      store: adsPerformance(),

      hideFilter: true,
      ex11: true,
      ex12: true,
      chartDatareport: "",
      checkAll: false,
      dialog: false,
      campaign_id: [],
      campaign_leads: [],
      startTimeCampign: null,
      endTimeCampaign: null,
      rowtype: null,
      campaignStatus: null,
      campaignId: null,
      campaignName: null,
      rowad_account_id: null,
      generalStore: useGeneralStore(),
      statusItems: [this.$t("PAUSED"), this.$t("ACTIVE"), this.$t("Completed")],
      data: {
        labels: [
          "impressionSum",
          "Amount Spent",
          "leadsSum",
          "swipesSum",
          "campaign_sum",
        ],
        datasets: [
          {
            label: "snapchat",
            data: [40, 150, 180, 200, 90],
            backgroundColor: "rgba(65, 135, 139, 1)",
            borderColor: "transparent",
            borderWidth: 1,
            borderRadius: 15,
          },
          {
            label: "Facebook",
            data: [40, 150, 180, 200, 90],
            backgroundColor: "rgba(65, 135, 139, 1)",
            borderColor: "transparent",
            borderWidth: 1,
            borderRadius: 15,
          },
          {
            label: "TikTok",
            data: [40, 150, 180, 200, 90],
            backgroundColor: "rgba(65, 135, 139, 1)",
            borderColor: "transparent",
            borderWidth: 1,
            borderRadius: 15,
          },
          {
            label: "Instagram",
            data: [40, 150, 180, 200, 90],
            backgroundColor: "rgba(65, 135, 139, 1)",
            borderColor: "transparent",
            borderWidth: 1,
            borderRadius: 15,
          },
          {
            label: "X (Twitter)",
            data: [40, 150, 180, 200, 90],
            backgroundColor: "rgba(65, 135, 139, 1)",
            borderColor: "transparent",
            borderWidth: 1,
            borderRadius: 15,
          },
          {
            label: "Google",
            data: [40, 150, 180, 200, 90],
            backgroundColor: "rgba(65, 135, 139, 1)",
            borderColor: "transparent",
            borderWidth: 1,
            borderRadius: 15,
          },
        ],
        options: {
          responsive: true,
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      },
      platformItems: [
        {
          platform: this.$t("snapchat"),
        },
        {
          platform: this.$t("facebook"),
        },
        {
          platform: this.$t("tiktok"),
        },
      ],

      loading: false,
      campaigns: [],
      total: 0,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    exportTable() {
      this.$refs.tableRef.exportTableToExcel();
    },
    ApplyFilter() {
      this.page = 1;
      this.store.getData(this.page, this.perPage);
    },
    toggleFilter() {
      this.store.selectedPlatform = null;
      this.store.selectedStatus = null;
      this.store.selectedDate = [];
      this.store.start_date = null;
      this.store.end_date = null;
      this.page = 1;
      this.store.getData(this.page, this.perPage);
    },
    formatLifetimeSpend(value) {
      if (!value || isNaN(value)) return 0;
      return Math.ceil(value / 1_000_000);
    },
    toggleAllCheckboxes() {},
    async adsReportStatusFunc() {
      this.store.adsReportStatus = !this.store.adsReportStatus;
      try {
        const response = await apiClient.get("/get/chart/insights", {
          params: {
            snap_ad_account_id: this.store.snap_ad_account_id,
            tiktok_advertiser_id: this.store.tiktok_advertiser_id,
            facebook_ad_account_id: this.store.facebook_ad_account_id,
          },
        });
        const insight = response.data.data;

        const labels = [
          "impressionSum",
          "Amount Spent",
          "leadsSum",
          "swipesSum",
          "campaign_sum",
        ];

        const chartData = {
          labels: [
            "impressionSum",
            "Amount Spent",
            "leadsSum",
            "swipesSum",
            "campaign_sum",
          ],
          datasets: [
            {
              label: "Snapchat",
              data: [
                insight.impressions.snapchat,
                insight.spend.snapchat,
                insight.native_leads.snapchat,
                insight.swipes.snapchat, // ← الصح هنا مش clicks
                insight.campaign_sum.snapchat,
              ],
              backgroundColor: "rgb(255 229 31)",
              borderColor: "transparent",
              borderWidth: 1,
              borderRadius: 15,
            },
            {
              label: "Facebook",
              data: [
                insight.impressions.facebook,
                insight.spend.facebook,
                insight.native_leads.facebook,
                insight.swipes.facebook, // ← برضه هنا
                insight.campaign_sum.facebook,
              ],
              backgroundColor: "rgba(65, 135, 139, 1)",
              borderColor: "transparent",
              borderWidth: 1,
              borderRadius: 15,
            },
            {
              label: "TikTok",
              data: [
                insight.impressions.tiktok,
                insight.spend.tiktok,
                insight.native_leads.tiktok,
                insight.swipes.tiktok, // ← وهنا كمان
                insight.campaign_sum.tiktok,
              ],
              backgroundColor: "rgba(100, 100, 255, 0.8)",
              borderColor: "transparent",
              borderWidth: 1,
              borderRadius: 15,
            },
          ],
        };
        this.chartData = chartData; // if you're binding to a reactive chart
        this.store.data = chartData;
      } catch (error) {
        console.error("Failed to fetch insights:", error);
      }
    },
    async handleStatusChange(item) {
      const oldStatus = item.status === "ACTIVE" ? "PAUSED" : "ACTIVE";
      item.loading = true;

      try {
        await this.changeStatus(
          item.status,
          item.id,
          item.name,
          item.start_time,
          item.end_time,
          item.type,
          item.ad_account_id,
          item.advertiser_id,
          item.campaign_id
        );
      } catch (error) {
        item.status = oldStatus;
      } finally {
        item.loading = false;
      }
    },
    async changeStatus(
      status,
      id,
      name,
      start_time,
      end_time,
      type,
      ad_account_id,
      advertiser_id,
      campaign_id
    ) {
      let requestData = {};

      if (type === "facebook") {
        requestData = {
          status: String(status) === "PAUSED" ? "ACTIVE" : "PAUSED",
          campaign_id: id,
          type: type,
        };
      } else if (type === "snapchat") {
        requestData = {
          status: String(status) === "PAUSED" ? "ACTIVE" : "PAUSED",
          type: type,
          ad_account_id: ad_account_id,
          id: id,
          name: name,
          start_time: start_time,
          end_time: end_time,
        };
      } else if (type === "tiktok") {
        requestData = {
          operation_status: String(status) === "PAUSED" ? "ENABLE" : "DISABLE",
          type: type,
          advertiser_id: advertiser_id,
          campaign_ids: { 0: campaign_id },
        };
      }
      try {
        await apiClient.post(`/ad-performance/update/campaign/status`, requestData);
        toast(`Your status updated but it may take a few minutes to take effect`, {
          type: "success",
        });
      } catch (error) {
        console.error("Error updating status:", error);
        toast(`Failed to update status`, {
          type: "error",
        });
      }
    },

    getFirstAndLastDate(dates) {
      if (!dates || !Array.isArray(dates) || dates.length === 0) {
        throw new Error("Invalid dates array");
      }
      const sortedDates = dates.sort((a, b) => new Date(a) - new Date(b));
      const firstDate = new Date(sortedDates[0]);
      const lastDate = new Date(sortedDates[sortedDates.length - 1]);
      const formatDate = (date) => date.toISOString().split("T")[0];
      return {
        firstDate: formatDate(firstDate),
        lastDate: formatDate(lastDate),
      };
    },
    showAnalisyes(id, ad_account_id, type) {
      this.$router.push(`/ads-performance/${ad_account_id}/${type}/${id}`);
    },
    copyRowData(row) {
      const rowData = {
        campaign_name: row.name,
        platform: row.type,
        Amount_Spent: this.formatLifetimeSpend(row.lifetime_spend_cap_micro),
        status: row.status,
        cost_per_result: Math.round(row.calculations.costPerClick * 100) / 100,
        Paid_Impressions: row.stats.impressions / 100,
        Clicks: row.stats.clicks,
      };

      const textToCopy = Object.entries(rowData)
        .map(([key, value]) => `${key}: ${value}`)
        .join("\n");

      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          this.generalStore.showSnackbar(
            "Row data copied to clipboard",
            "success"
          );
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
          this.generalStore.showSnackbar("Failed to copy data", "error");
        });
    },
    onPageChange(newPage) {
      this.page = newPage;
      this.store.getData(this.page, this.perPage);
    },

    onPerPageChange(newPerPage) {
      this.perPage = newPerPage;
      this.store.getData(this.page, this.perPage);
    },
  },
  watch: {
    checkAll(newValue) {
      this.filteredTableData.forEach((row) => {
        row.checked = newValue;
      });
    },
    // "store.selectedDate"(newVal) {
    //   if (newVal.length > 0) {
    //     let dates = this.getFirstAndLastDate(newVal);
    //     this.store.start_date = dates.firstDate;
    //     this.store.end_date = dates.lastDate;
    //   } else {
    //     this.store.start_date = null;
    //     this.store.end_date = null;
    //   }
    // },
    "store.selectedDate"(newArr) {
      this.store.setSelectedDate(newArr); // بيحدث start_date / end_date
    },
    "store.selectedPlatform"(newVal) {
      this.store.setPlatform(newVal);
    },
    "store.selectedStatus"(newVal) {
      this.store.setStatus(newVal);
    },
  },
  async mounted() {},
  computed: {
    store() {
      return adsPerformance();
    },
    isChartDataEmpty() {
      if (!this.store.data?.datasets?.length) {
        return true;
      }
      return this.store.data.datasets.every((dataset) =>
        dataset.data.every((value) => value === 0)
      );
    },
    paginatedTableData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.store.tableData.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.store.tableData.length / this.itemsPerPage);
    },
    filteredTableData() {
      return this.store.tableData.filter((row) => {
        const isStatusMatch =
          !this.selectedStatus || row.status === this.selectedStatus;
        const isDateInRange =
          !this.selectedDate.length ||
          (new Date(row.start_time) >= new Date(this.selectedDate[0]) &&
            new Date(row.end_time) <= new Date(this.selectedDate[1]));
        const isPlatformMatch =
          !this.selectedPlatform ||
          row.platform === this.selectedPlatform.platform;
        return isStatusMatch && isDateInRange && isPlatformMatch;
      });
    },
  },
};
</script>
